<a [routerLink]="'/process-detail'" class="W100">
    <ng-container *ngIf="!!order">
        <!-- DESKTOP -->
        <section class="edp-card-widget edp-es-widget-order card desktop">
            <div class="edp-es-widget-order-container">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                <div class="card-body">
                    <p class="title">{{ "pt.edp.edponline.es.widget.order.body.title" | translate }}</p>
                    <p class="status">{{ order.stage | translate }}</p>
                </div>
                <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
            </div>
            <div class="edp-es-widget-order-container">
                <ng-container *ngTemplateOutlet="stepsTemplate"></ng-container>
            </div>
        </section>

        <!-- MOBILE -->
        <section class="edp-card-widget edp-es-widget-order card mobile">
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            <div class="card-body pt-0">
                <ng-container *ngTemplateOutlet="stepsTemplate"></ng-container>
            </div>
            <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </section>
    </ng-container>

    <ng-template #stepsTemplate>
        <div class="widget-steps">
            <span class="widget-steps-title">{{ "pt.edp.edponline.es.widget.order.steps.title" | translate }}</span>
            <div class="d-flex justify-content-center">
                <edp-es-order-steps [order]="order"></edp-es-order-steps>
            </div>
        </div>
    </ng-template>

    <ng-template #headerTemplate>
        <div class="card-header">
            <span class="card-title">{{ "pt.edp.edponline.es.widget.order.title" | translate }}</span>
            <span class="card-icon">
                <i class="icon-edponline-Bop-007" aria-hidden="true"></i>
            </span>
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="card-footer cursor-pointer">
            <div class="d-flex align-items-center">
                <i class="icon" [ngClass]="order.icon" [style.color]="order.color"></i>
                <div class="card-footer-description d-inline">
                    <span class="card-footer-description-title" [style.color]="order.color">{{ order.title | translate }}&nbsp;</span>
                    <span [innerHTML]="order.description | translate: { DAY_MONTH: dateFormatted }"></span>
                </div>
            </div>
        </div>
    </ng-template>
</a>
